import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router";
import MUILink from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import { INFO_EMAIL_ADDRESS } from "../../constants/general";

export const Link = styled(MUILink)`
  cursor: pointer;
  display: inline-block;
  text-decoration: underline !important;
  color: #007bff !important;
`;

export const PrivacyPolicyPage = () => {
  const { goBack } = useHistory();

  return (
    <section>
      <Link onClick={goBack}>Back</Link>
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography gutterBottom align="justify">
        RoomSync provides this Privacy Policy to inform users of our policies and procedures regarding the collection,
        use and disclosure of personally identifiable information received from users of this website, located at
        admin.roomsync.com (“Site” ). This Privacy Policy may be updated from time to time for any reason; each version
        will apply to information collected while it was in place. We will notify you of any material changes to our
        Privacy Policy by posting the new Privacy Policy on our Site. You are advised to consult this Privacy Policy
        regularly for any changes.
      </Typography>
      <Typography gutterBottom align="justify">
        By using our Site you are consenting to our processing of your information as set forth in this Privacy Policy
        now and as amended by us. “Processing” means using cookies on a computer or using or touching information in any
        way, including, but not limited to, collecting, storing, deleting, using, combining and disclosing information,
        all of which activities will take place in the United States. If you reside outside the U.S. your personally
        identifiable information will be transferred to the U.S., and processed and stored there under U.S. privacy
        standards. By visiting our Site and providing information to us, you consent to such transfer to, and processing
        in, the US.
      </Typography>
      <Typography gutterBottom align="justify">
        If you have any questions or comments about this Privacy Policy or our use of your personally identifiable
        information, please contact us at <Link href={`mailto:${INFO_EMAIL_ADDRESS}`}>{INFO_EMAIL_ADDRESS}</Link>.
      </Typography>
      <Typography gutterBottom align="justify">
        Information Collection and Use – Our primary goals in collecting personally identifiable information are to
        provide you with the product and services made available through the Site, including, but not limited, to the
        Service, to communicate with you, and to manage your registered user account, if you have one.
      </Typography>
      <Typography gutterBottom align="justify">
        Information Collected Upon Registration – If you desire to have access to certain restricted sections of the
        Site, you will be required to become a registered user, and to submit certain personally identifiable
        information to RoomSync. Personally identifiable information that we may collect in such instances may include
        your IP address, full user name, password, email address, city, time zone, telephone number, and other
        information that you decide to provide us with.
      </Typography>
      <Typography gutterBottom align="justify">
        Use of Contact Information – It is RoomSync policy to never use your contact information to market to you or in
        any other way share said information without parties outside of the RoomSync organization.
      </Typography>
      <Typography gutterBottom align="justify">
        Log Data – When you visit the Site, our servers automatically record information that your browser sends
        whenever you visit a website (“Log Data” ). This Log Data may include information such as your IP address,
        browser type or the domain from which you are visiting, the web-pages you visit, the search terms you use, and
        any advertisements on which you click. For most users accessing the Internet from an Internet service provider
        the IP address will be different every time you log on. We use Log Data to monitor the use of the Site and of
        our Service, and for the Site’s technical administration. We do not associate your IP address with any other
        personally identifiable information to identify you personally, except in case of violation of the Terms of
        Service
      </Typography>
      <Typography gutterBottom align="justify">
        Cookies – Like many websites, we also use “cookie” technology to collect additional website usage data and to
        improve the Site and our service. A cookie is a small data file that we transfer to your computer’s hard disk.
        We do not use cookies to collect personally identifiable information. RoomSync may use both session cookies and
        persistent cookies to better understand how you interact with the Site and our Service, to monitor aggregate
        usage by our users and web traffic routing on the Site, and to improve the Site and our services. A session
        cookie enables certain features of the Site and our service and is deleted from your computer when you
        disconnect from or leave the Site. A persistent cookie remains after you close your browser and may be used by
        your browser on subsequent visits to the Site. Persistent cookies can be removed by following your web browser
        help file directions. Most Internet browsers automatically accept cookies. You can instruct your browser, by
        editing its options, to stop accepting cookies or to prompt you before accepting a cookie from the websites you
        visit.
      </Typography>
      <Typography gutterBottom align="justify">
        Security – RoomSync is very concerned about safeguarding the confidentiality of your personally identifiable
        information. We employ administrative, physical and electronic measures designed to protect your information
        from unauthorized access.
      </Typography>
      <Typography gutterBottom align="justify">
        We will make any legally-required disclosures of any breach of the security, confidentiality, or integrity of
        your unencrypted electronically stored personal data to you via email or conspicuous posting on this Site in the
        most expedient time possible and without unreasonable delay, consistent with (i) the legitimate needs of law
        enforcement or (ii) any measures necessary to determine the scope of the breach and restore the reasonable
        integrity of the data system.
      </Typography>
      <Typography gutterBottom align="justify">
        Links to Other Websites – Our Site contains links to other websites. The fact that we link to a website is not
        an endorsement, authorization or representation of our affiliation with that third party. We do not exercise
        control over third party websites. These other websites may place their own cookies or other files on your
        computer, collect data or solicit personally identifiable information from you. Other sites follow different
        rules regarding the use or disclosure of the personally identifiable information you submit to them. We
        encourage you to read the privacy policies or statements of the other websites you visit.
      </Typography>
    </section>
  );
};

export const PRIVACY_POLICY_PAGE_URL = "/privacy-policy";
